import { Phone } from "lucide-react";
import { BUSINESS, IMG } from "@/lib/content";
import { goToEstimate } from "@/lib/scroll";
import { Eyebrow, Reveal } from "./Reveal";

export const Remnants = () => (
  <section id="remnants" data-testid="remnants-section" className="relative overflow-hidden py-24 lg:py-32">
    <img src={IMG.darkStone} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover" />
    <div className="absolute inset-0 bg-[#0B0F17]/60" />
    <div className="relative mx-auto flex max-w-[1400px] flex-col gap-10 px-5 sm:px-8 lg:flex-row lg:items-end lg:justify-between">
      <div className="max-w-2xl">
        <Reveal><Eyebrow>Remnants</Eyebrow></Reveal>
        <Reveal delay={0.1}><h2 className="mt-5 font-display text-4xl leading-[1.05] text-[#F5F0E6] sm:text-5xl lg:text-6xl">Premium stone for <span className="italic text-[#CDA85B]">smaller projects.</span></h2></Reveal>
        <Reveal delay={0.2}><p className="mt-6 text-[#D6D3CC]">Leftover pieces from full slabs are perfect for vanities, bar tops, laundry rooms and accent pieces. Inventory changes often, so ask what is in the shop right now.</p></Reveal>
      </div>
      <Reveal delay={0.3} className="flex flex-col gap-3 sm:flex-row">
        <a href={BUSINESS.phoneHref} data-testid="remnants-call-btn" className="ks-btn-ghost justify-center"><Phone className="h-4 w-4" /> Ask about remnants</a>
        <button onClick={() => goToEstimate({ message: "I'm interested in remnant pieces for a smaller project." })} data-testid="remnants-quote-btn" className="ks-btn-gold justify-center">Request remnant pricing</button>
      </Reveal>
    </div>
  </section>
);
